import { collection, doc, getDoc, getDocs, setDoc, updateDoc, query, where } from "firebase/firestore";
import { db } from "../config/firebase";

const COLLECTION = "nguoiDung";

export const getAllUsers = async () => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
};

export const getUserByUid = async (uid) => {
  const userDoc = await getDoc(doc(db, COLLECTION, uid));
  return userDoc.exists() ? { uid: userDoc.id, ...userDoc.data() } : null;
};

export const createUser = async (uid, data) => {
  await setDoc(doc(db, COLLECTION, uid), {
    ...data,
    ngayTao: new Date().toISOString(),
    trangThai: data.trangThai || 'dangHoatDong',
  });
};

export const updateUser = async (uid, data) => {
  await updateDoc(doc(db, COLLECTION, uid), {
    ...data,
    ngayCapNhat: new Date().toISOString(),
  });
};

export const getUsersByRole = async (role) => {
  const q = query(collection(db, COLLECTION), where("vaiTro", "array-contains", role));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
};

// Lấy danh sách lớp học
export const getAllLopHoc = async () => {
  const snapshot = await getDocs(collection(db, "lopHoc"));
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// Lấy danh sách ngành
export const getAllNganh = async () => {
  const snapshot = await getDocs(collection(db, "nganh"));
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};